import { Fragment } from "react";
import { Field } from "../types";
import { Switch } from "../components/form";
import { useForm } from "../app/useForm";
import { renderPrice } from "../number";

export const RenderFieldValue = (field: Field) => {
  const { postData } = useForm();
  const postDataValue = postData[field.name as string];

  const { name, value, editable, hint } = field;
  let fieldValue = postDataValue ?? value;

  const unit = hint?.unit ?? "";
  const thousandSeparator = hint?.thousand_separator ?? "";

  if (thousandSeparator) {
    fieldValue = renderPrice(fieldValue as number, unit, thousandSeparator);
  } else if (unit) {
    fieldValue += ` ${unit}`;
  }

  return (
    <Fragment>
      {field.type === "boolean" ? (
        <Switch name={name} checked={value as boolean} disable={!editable} />
      ) : Array.isArray(fieldValue) ? (
        fieldValue.join(", ")
      ) : (
        fieldValue
      )}
    </Fragment>
  );
};
